import { render, staticRenderFns } from "./SurveyItem.vue?vue&type=template&id=85d752ce&scoped=true&"
import script from "./SurveyItem.vue?vue&type=script&lang=ts&"
export * from "./SurveyItem.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyItem.vue?vue&type=style&index=0&id=85d752ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d752ce",
  null
  
)

export default component.exports